













































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';

import {jsPDF} from 'jspdf';

import {Utils} from '@/utils/Utils';

@Component({})
export default class PDFTemplate extends Vue {
  @Prop({default: []}) listData!: [];
  @Prop({default: null}) shipDetails!: {};
  @Prop({default: null}) deckDetails!: {};

  @Prop({default: null}) title!: String;

  Utils = Utils;

  async htmlToPdf() {
    // this.genRatePdfInspectionlist();
    const doc = new jsPDF('p', 'pt', 'A3', true);
    const htmlRef: any = this.$refs.html2Pdf as InnerHTML;

    await doc.html(htmlRef);

    var string = fetch(doc.output('datauristring'))
      .then((res) => res.blob())
      .then((blob) => {
        let params = [
          'height=' + screen.height,
          'width=' + screen.width,
          'fullscreen=yes',
          'toolbar=' + 0,
          'location=' + 0,
          'menubar=' + 0,
        ].join(',');
        // window.open(URL.createObjectURL(blob), 'print', params);
        doc.save('inspectionlist.pdf');
      });
    this.$emit('stopLoader');
  }
  header = [
    {
      name: 'S.No',
      value: 'sno',
    },
    {
      name: `Inspection  ID`,
      value: 'dataCode',
    },
    {
      name: '#',
      value: 'totalInspections',
      sortable: true,
      headerType: 'number',
      asdcOrder: true,
      filter: true,
    },
    {
      name: 'Ship',
      value: 'shipName',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },
    {
      name: 'Deck',
      value: 'deckName',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },

    {
      name: 'Frame',
      value: 'frameNumber',
      sortable: true,
      headerType: 'number',
      asdcOrder: true,
      filter: true,
    },

    {
      name: 'Location',
      value: 'location',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },
    {
      name: 'Date',
      value: 'dataDate',
      sortable: true,
      headerType: 'date',
      asdcOrder: true,
      filter: true,
    },

    {
      name: 'Inspector',
      value: 'inspectorName',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },

    {
      name: 'Recipient',
      value: 'recipientUser',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },

    {
      name: 'Finding',
      value: 'finding',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
      // bindClass: 'finding',
    },
    {
      name: 'Severity',
      value: 'severity',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },

    {
      name: 'Voyage',
      value: 'voyageName',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },
    // {
    //   name: 'Voyage Condition',
    //   value: 'voyageCondition',
    //   sortable: true,
    //   headerType: 'text',
    //   asdcOrder: true,
    //   filter: true,
    //   bindClass: 'break-text space',
    // },
    {
      name: 'ReInspection Date',
      value: 'redataDate',
      sortable: true,
      headerType: 'date',
      asdcOrder: true,
      filter: true,
    },
    // {name: '#', value: 'status', sortable: false, headerType: 'text'},

    {
      name: 'Work Order',
      value: 'workOrder',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },
    // {
    //   name: 'Status',
    //   value: 'actionPlanStatus',
    //   sortable: true,
    //   headerType: 'text',
    //   asdcOrder: true,
    //   filter: true,
    // },
    // {name: 'View ', value: 'view'},
    // {name: 'Reinspection', value: 'redata'},

    // {name: 'Locate', value: 'locate'},
  ];

  generateData() {
    return this.listData.map((d: any, index) => {
      let data: any = {};
      data.sno = (index + 1).toString();
      data.dataCode = d.inspectionCode;
      data.totalInspections = d.totalInspections;
      data.shipName = d.shipName;
      data.deckName = d.deckName;
      data.frameNumber = d.frameNumber;
      data.location = d.frameSide ? d.frameSide : 'N/A';
      data.dataDate = Utils.formatDate(d.inspectionDate);
      data.inspectorName = d.inspectorName ? d.inspectorName : 'N/A';
      data.recipientUser = d.recipientUser;
      data.finding = d.finding;
      data.severity = d.severity;
      data.voyageName = d.voyageName;
      data.voyageCondition = d.voyageCondition;
      data.redataDate = Utils.formatDate(d.reinspectionDate);
      data.workOrder = d.workOrder;
      return data;
    });
  }

  createHeaderPdfTable() {
    let result = [];
    this.header.map((head) => {
      let data = {
        id: head.value,
        name: head.value,
        prompt: head.value,
        // width: 65,
        align: 'center',
        padding: 0,
      };
      result.push(data);
    });
    return result;
  }

  async genRatePdfInspectionlist() {
    let doc = new jsPDF();

    doc.table(1, 1, this.generateData(), this.createHeaderPdfTable(), {
      autoSize: true,
    });
    var string = doc.output('datauristring');
    var embed = "<embed width='100%' height='100%' src='" + string + "'/>";
    var x = await window.open();
    x.document.open();
    x.document.write(embed);
    x.document.close();
  }
}
